module.exports = __webpack_public_path__ + "img/Mobil_Serv-SM.2a35162c.png";